export const environment = {
  production: true,
  apiUrl: '/api',
  socketUrl: '/',
  firebase: {
    apiKey: "AIzaSyCf8YA8PY0bI-kuoYWMiwkNjeFCmb-w64k",
    authDomain: "khanh-hoa-noi-tieng-anh.firebaseapp.com",
    projectId: "khanh-hoa-noi-tieng-anh",
    storageBucket: "khanh-hoa-noi-tieng-anh.appspot.com",
    messagingSenderId: "746334075568",
    appId: "1:746334075568:web:73fe7c1d00d84dbd105975",
    measurementId: "G-JG110JP27C"
  },
  fbClientId: '549204803371057',
  ggApiKey: 'AIzaSyDguiLD6x3wTvAFGgG2uZ4wbqHh6nev1HE',
  ggClientId: '194526417835-jbg70jn3jle214v90osvlnatpdb78pei.apps.googleusercontent.com',
  fcmConfig: {
    fcmSw: '/student/firebase-messaging-sw.js',
  },
  GTM_ID: 'GTM-PT2PM66',
  rocketChatWss: 'wss://chat.khanhhoanoitienganh.org/websocket',
  rocketChatApi: 'https://chat.khanhhoanoitienganh.org/api/v1',
  recaptchaSiteKey: '6LcoexspAAAAADIb4iWeBVXO46l8LXeAFdnDoDYT'
};
